import React, { useRef } from 'react';
import styled from 'styled-components';
import { IoIosSend } from 'react-icons/io';
import { ButtonContainer } from '../styled/Button';
import { useChat } from '../context/ChatProvider';
import { createMessage } from "../context/MessageModel";
import {useTranslation} from "react-i18next";

const MessageForm = styled.form`
    padding: 0.5vw 0;
    display: flex;
    align-items: center;
    height: 10%;
    border-top: 1px solid rgba(0, 0, 0, 0.08);

    & input {
        flex: 1;
        height: 100%;
        width: 100%;
        border: none;
    }
`;

const ChatForm = () => {
    const inputRef = useRef(null);
    const { sendMessage, currentRoom, loading } = useChat(); // Use loading from context
    const { t } = useTranslation();

    const onSubmit = (e) => {
        e.preventDefault();
        const messageText = inputRef.current.value;

        if (messageText.trim() && currentRoom && !loading) {
            const message = createMessage(
                'User', // Example sender name
                'Bot',  // Example receiver name
                messageText,
                currentRoom.current_thread_id
            );

            sendMessage(message);
        }

        inputRef.current.value = ''; // Clear input field after sending
    };

    return (
        <MessageForm onSubmit={onSubmit}>
            <input
                type="text"
                placeholder={t('messages.placeholder') || 'Logout'}
                ref={inputRef}
            />
            <ButtonContainer flex="0" padding="0" active={!loading} size="2.2em" borderRadius="50%">
                <button disabled={loading}> {/* Disable button when loading */}
                    <IoIosSend fill={loading ? "#ccc" : "#fff"} /> {/* Change icon color when disabled */}
                </button>
            </ButtonContainer>
        </MessageForm>
    );
};

export default ChatForm;
